import React, { useState } from "react";
import { Button } from "../../../../design/button";
import { DocumentArrowUpIcon } from "@heroicons/react/20/solid";
import ImportCaseWizard from "./ImportCaseWizard";

interface ImportCaseFromPDFButtonProps {
  className?: string;
}

const ImportCaseFromPDFButton: React.FC<ImportCaseFromPDFButtonProps> = ({
  className,
}) => {
  const [isWizardOpen, setIsWizardOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        outline
        onClick={() => setIsWizardOpen(true)}
        className={className}
      >
        <DocumentArrowUpIcon className="h-4 w-4" />
        Import from PDF
      </Button>

      <ImportCaseWizard
        isOpen={isWizardOpen}
        onClose={() => setIsWizardOpen(false)}
      />
    </>
  );
};

export default ImportCaseFromPDFButton;
